import type { AppRole } from "../types/auth";

export const TRAINER_ROLES = ["tenant_owner", "trainer", "assistant"] as const;

export const ROLE_REDIRECTS: Record<AppRole, string> = {
  platform_admin: "/admin",
  tenant_owner: "/trainer",
  trainer: "/trainer",
  assistant: "/trainer",
  client: "/client/onboarding",
};

export const ROLE_LABELS: Record<AppRole, string> = {
  platform_admin: "Platform admin",
  tenant_owner: "Workspace owner",
  trainer: "Trainer",
  assistant: "Assistant",
  client: "Client",
};

export function getRedirectForRole(role: AppRole | null | undefined) {
  return role ? ROLE_REDIRECTS[role] : "/";
}

export function getRoleLabel(role: AppRole | null | undefined) {
  return role ? ROLE_LABELS[role] : "No role";
}
